import Icon from "@/components/Icon";
import Tooltip from "@/components/Tooltip";
import type { MaterialNames } from "@/components/material_symbol_names";
import { StatusType } from "./types";

export type StatusTag = { color: string; icon: MaterialNames };

export const STATUS_MAP: Record<StatusType, StatusTag> = {
  [StatusType.WARNING]: { color: "text-extended-warning-brand-color", icon: "emergency_home" },
  [StatusType.ERROR]: { color: "text-sys-brand-error", icon: "error" }
};

export const renderStatusIcon = (status: StatusType, statusMessage: string[] | undefined) => {
  const { color, icon } = STATUS_MAP[status] || { color: "text-sys-brand-error", icon: "error" };
  return (
    <div className="relative right-2">
      {statusMessage ? (
        <Tooltip
          variant="plain"
          supportingText={statusMessage.join(",\r\n")}
          color="black"
          menuCorner="end-start"
          anchorCorner="start-start"
          anchorClassName="md:-mx-0 md:px-0"
        >
          <Icon name={icon} className={color} />
        </Tooltip>
      ) : (
        <Icon name={icon} className={color} />
      )}
    </div>
  );
};

export function filterErrorsByKeys(data: Record<string, string[]>[], filterKeys: string[]) {
  return data.filter((item) => {
    let key = Object.keys(item)[0];
    return !filterKeys.includes(key);
  });
}

export function getMessagesById(array: Record<string, string[]>[], id: string) {
  return array?.flatMap((item) => item[id] || []);
}

export function getStatusById(errors: Record<string, string[]>[], warnings: Record<string, string[]>[], id: string) {
  let status;
  switch (true) {
    case getMessagesById(errors, id).length > 0:
      status = StatusType.ERROR;
      break;
    case getMessagesById(warnings, id).length > 0:
      status = StatusType.WARNING;
      break;
    default:
      status = null;
  }
  return {
    status,
    statusMessage: errors.concat(warnings).flatMap((obj) => obj[id] || [])
  };
}
